import { compact } from 'lodash-es';
import { relationshipModel } from '~/models';
// ============ Enums ============
export var PreviewState = /*#__PURE__*/ function(PreviewState) {
    PreviewState["Preview"] = "preview";
    PreviewState["SetupBrand"] = "setupBrand";
    return PreviewState;
}({});
export var COBStep = /*#__PURE__*/ function(COBStep) {
    COBStep["welcome"] = "welcome";
    COBStep["selectAPackage"] = "packages";
    COBStep["reviewServices"] = "services";
    COBStep["termsOfService1"] = "terms-of-service-1";
    COBStep["termsOfService2"] = "terms-of-service-2";
    COBStep["termsOfService3"] = "terms-of-service-3";
    COBStep["termsOfService4"] = "terms-of-service-4";
    COBStep["approveTerms"] = "terms";
    COBStep["accountantAccess"] = "accountant-access";
    COBStep["paymentMethod"] = "payment-method";
    COBStep["introVideo"] = "intro-video";
    COBStep["allSet"] = "all-set";
    COBStep["introduction"] = "introduction";
    COBStep["signAndApprove"] = "sign-and-approve";
    return COBStep;
}({});
export const termsOfServiceStepIndex = {
    ["terms-of-service-1"]: 0,
    ["terms-of-service-2"]: 1,
    ["terms-of-service-3"]: 2,
    ["terms-of-service-4"]: 3
};
// ============ Shared Functions ============
export function getStepName(step, relationship) {
    const getTermsOfServiceName = (index)=>{
        var _relationship_legalTermsDocuments;
        if (((_relationship_legalTermsDocuments = relationship.legalTermsDocuments) === null || _relationship_legalTermsDocuments === void 0 ? void 0 : _relationship_legalTermsDocuments.length) > 1) {
            var _ref;
            var _relationship_legalTermsDocuments_index, _relationship_legalTermsDocuments1;
            return "Review ".concat((_ref = (_relationship_legalTermsDocuments1 = relationship.legalTermsDocuments) === null || _relationship_legalTermsDocuments1 === void 0 ? void 0 : (_relationship_legalTermsDocuments_index = _relationship_legalTermsDocuments1[index]) === null || _relationship_legalTermsDocuments_index === void 0 ? void 0 : _relationship_legalTermsDocuments_index.displayName.replace(/\.pdf$/i, '')) !== null && _ref !== void 0 ? _ref : '');
        }
        return "Review Terms of Service";
    };
    switch(step){
        case "welcome":
        case "introduction":
            return 'Introduction';
        case "packages":
            return 'Select a Package';
        case "services":
            return 'Review Services';
        case "terms":
            return 'Review Additional Terms';
        case "accountant-access":
            return 'Grant Accountant Access';
        case "payment-method":
            return 'Add a Payment Method';
        case "all-set":
            return "You're all set!";
        case "intro-video":
            return 'Welcome video';
        case "sign-and-approve":
            return 'Sign & approve';
        case "terms-of-service-1":
            return getTermsOfServiceName(0);
        case "terms-of-service-2":
            return getTermsOfServiceName(1);
        case "terms-of-service-3":
            return getTermsOfServiceName(2);
        case "terms-of-service-4":
            return getTermsOfServiceName(3);
    }
}
/**
 * Returns the common middle steps (between welcome/introduction and allSet) based on relationship configuration.
 * This is shared between V1 and V2 client onboarding flows.
 */ export function getCommonReachableSteps(relationship) {
    var _ref;
    var _relationship_legalTermsDocuments;
    const hasPaymentMethod = relationship.requirePaymentMethod || relationship.isSample;
    const hasPackages = !!relationship.serviceBundles;
    const termsOfServiceSteps = [
        "terms-of-service-1",
        "terms-of-service-2",
        "terms-of-service-3",
        "terms-of-service-4"
    ];
    const termsOfServiceCount = (_ref = (_relationship_legalTermsDocuments = relationship.legalTermsDocuments) === null || _relationship_legalTermsDocuments === void 0 ? void 0 : _relationship_legalTermsDocuments.length) !== null && _ref !== void 0 ? _ref : 0;
    while(termsOfServiceSteps.length > termsOfServiceCount){
        termsOfServiceSteps.pop();
    }
    return compact([
        relationshipModel.hasIntroVideos(relationship) && "intro-video",
        hasPackages && "packages",
        "services",
        ...termsOfServiceSteps,
        "terms",
        hasPaymentMethod && "payment-method"
    ]);
}
